import { createColumnDate, createColumnInput, createColumnSelect } from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import store from "../../../../store";
import { putField } from "../../../../utils/form";
import lodash from "lodash";
import { callObjectiveType } from "../../to-whom/request/request.section";

export const callDocumentStatus = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "DOCUMENT_STATUS", value: searchQuery });

export const requiredSolidOrLiquid = ({ data, key }) => {
    return {
        validator: () => {
            const modelRef = data.useForm?.modelRef || data.form;
            const model = key ? lodash.get(modelRef, key) : modelRef;
            if (model.refToWhomTemp.isSolid !== true && model.refToWhomTemp.isLiquid !== true) {
                return Promise.reject(i18n.global.t("views.request.hazInfo.error.isSolidOrIsLiquid"));
            }
            return Promise.resolve();
        },
        trigger: "change"
    };
};

export const createColumns = () => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("model.toWhom.refUserCompany"),
            dataIndex: "refUserCompany.companyNameTh",
            customRender: ({ record }) => {
                if (record.refUserCompany?.refPersonType?.key === "1") {
                    return <div>{record.refUserCompany?.companyNameTh}</div>;
                }
                return <div>{record.refUserCompany?.fullNameTh}</div>;
            }
        }),
        createColumnInput({ title: () => i18n.global.t("model.toWhom.approveCode"), dataIndex: "approveCode", align: "center" }),
        createColumnDate({ title: () => i18n.global.t("model.toWhom.expireDate"), dataIndex: "expireDate", align: "center" }),
        createColumnInput({ title: () => i18n.global.t("model.toWhom.refHazDiscussAppoveCode"), dataIndex: "refHazDiscuss.approveCode" }),
        createColumnSelect({
            title: () => i18n.global.t("model.toWhom.refObjective"),
            dataIndex: "refObjective.value",
            customRender: ({ record }) => <div>{record.refObjective?.value}</div>,
            inputProp: () => ({ list: callObjectiveType, optLabel: "value" }),
            search: { name: "refObjective.id" }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.toWhom.refStatus"),
            dataIndex: "refStatus.value",
            customRender: ({ record }) => <div>{record.refStatus?.value}</div>,
            inputProp: () => ({ list: callDocumentStatus, optLabel: "value" }),
            align: "center",
            search: { name: "refStatus.id" },
        })
    ];
    return columns;
};

export const createField = ({ data }) => {
    return putField({
        data,
        fields: []
    });
};
